// extracted by mini-css-extract-plugin
export default {"button":"ButtonWithImage_button__5N3Pg","button__image":"ButtonWithImage_button__image__5oPYD","button__action-text":"ButtonWithImage_button__action-text__Lx+m3"};